import { render, staticRenderFns } from "./CreditCalculation.vue?vue&type=template&id=35a5601c&"
import script from "./CreditCalculation.vue?vue&type=script&lang=js&"
export * from "./CreditCalculation.vue?vue&type=script&lang=js&"
import style0 from "./CreditCalculation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports